
function makeEditFrom(name, modelName, fields) {
    module.directive(name, /* @ngInject */ function(ModelService) {
        var scope = {};
        scope[modelName] = '=';
        return {
            restrict: 'E',
            templateUrl: 'programs/basic/' + name,
            scope: scope,
            require: '^basicForm',
            link: function(scope, element, attrs, basicForm) {
                scope.data = ModelService.copyFields(scope[modelName], fields);
                basicForm.data = scope.data;
                scope.form = basicForm.getForm();

                basicForm.save = function(data) {
                    return ModelService.patchModel(scope[modelName], data);
                };
            },
        };
    });
}

makeEditFrom('programNameForm', 'program', ['program_name']);
makeEditFrom('programPhoneForm', 'program', ['phone', 'fax'])
makeEditFrom('programRuralForm', 'program', ['rural_status', 'tribal_status'])

module.directive('programSponsorForm', function(ModelService) {
    fields = ['sponsor_name', 'sponsor_website',
              'sponsor_phone', 'sponsor_fax'];
    return {
        restrict: 'E',
        templateUrl: 'programs/basic/programSponsorForm',
        scope: {'program': '=', canDelete: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = ModelService.copyFields(scope.program, fields);
            basicForm.data = scope.data;
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                console.log(data);
                return ModelService.patchModel(scope.program, data);
            };

            basicForm.setDeleteFunctions(function() {
                var data = {}, i;
                for (i = 0; i < fields.length; i++) {
                    data[fields[i]] = null;
                }
                return ModelService.patchModel(scope.program, data);
            }, function() {
                return scope.canDelete;
            });
        },
    };
});

module.directive('programAddressForm', function(ModelService) {
    var fields = ['address_1', 'address_2', 'city', 'state_abbr', 'postal_code'];
    return {
        restrict: 'E',
        templateUrl: 'programs/basic/programAddressForm',
        scope: {program: '=', programAddress: '=', canDelete:'='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            if (scope.programAddress) {
                scope.data = ModelService.copyFields(scope.programAddress, fields);
            } else {
                scope.data = {address_type: attrs.addressType || 'billing'};
            }
            basicForm.data = scope.data;
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                if (scope.programAddress) {
                    return ModelService.patchModel(scope.programAddress, data);
                } else {
                    return ModelService.postModelRelation(scope.program, 'addresses', data);
                }
            };

            basicForm.setDeleteFunctions(function() {
                return ModelService.deleteModel(scope.programAddress);
            }, function() {
                return scope.canDelete &&
                    scope.programAddress &&
                    scope.programAddress.address_type !== 'main';
            })
        },
    };
});


module.directive('programWebsitesForm', function(ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'programs/basic/programWebsitesForm',
        scope: {program: '=', websites: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            var webType;
            scope.data = basicForm.data = {};
            scope.form = basicForm.getForm();

            for (webType in scope.websites) {
                scope.data[webType] = scope.websites[webType].url;
            }

            basicForm.save = function(data) {
                ModelService.patchModel(scope.program, {websites: data});
            };
        },
    };
});


module.cC({
    name: 'ProgramEditController',
    inject: ['$scope', 'details', 'addresses', 'websites', 'ModelService', 'log'],

    data: {
        details: 'details',
        addresses: 'addresses',
        websites: 'websites',
        log: 'log',
    },

    listen: {
        program: {
            update: '_updateLog',
        },
        website: {
            update: '_refreshWebsites',
            create: '_refreshWebsites',
            delete: '_refreshWebsites',
        },
        program_address: {
            update: '_updateLog',
            create: '_createBilling',
            delete: '_removeBilling',
        },
    },

    methods: {

        _updateLog: function() {
            this.log.refresh();
        },

        _refreshWebsites: function(websiteId, programId) {
            var self = this;
            this._updateLog();
            if (programId === self.details.id) {
                this.ModelService.debouncedRelation('program', programId, 'websites')
                    .then(function(websites) {
                        angular.copy(websites, self.websites);
                    });
            }
        },

        _createBilling: function(addressId, programId) {
            if (programId === this.details.id) {
                this._updateLog();
                this.ModelService.debouncedGet('program_address', addressId)
                    .then(this._appendBilling);
            }
        },

        _appendBilling: function(address) {
            this.addresses[address.address_type] = address;
        },

        _removeBilling: function(addressId, programId) {
            this._updateLog();
            if (programId === this.details.id) {
                for (var type in this.addresses) {
                    if (this.addresses[type].id === addressId) {
                        delete this.addresses[type];
                        return
                    }
                }
            }
        }
    }
});
